module.exports = __webpack_public_path__ + "media/images/top/shoplist-logo-ad330327d0f994b587b5e0cf02a4d6cd.svg";